import { mapToCamelCase } from '@consigli/utils';
import { z } from 'zod';
export const unchargeableReasonSchema = z.enum([
    'project_status_does_not_allow_charges',
    'project_dates_do_not_allow_charges',
    'task_is_not_chargeable',
    'task_passed_active_end_date',
    'transaction_control_does_not_allow_charges',
]);
export const oracleProjectSchema = z
    .object({
    project_number: z.string(),
    project_name: z.string(),
    project_type_class_code: z.string().nullable(),
    customer_name: z.string().nullable(),
    chargeable: z.boolean(),
    unchargeable_reason: unchargeableReasonSchema.nullable(),
})
    .transform(mapToCamelCase);
const SHARED_PROJECT_TYPE_CLASS_CODES = ['INDIRECT', 'BUSINESS_DEVELOPMENT'];
/**
 * Indirect and Bid & Proposal (business development) Oracle projects are shared
 * by many users, so their exact Oracle name collides. Per the AI4Eng
 * integration decision, these projects get a free-form, user-editable name
 * while Direct projects must keep the exact Oracle name.
 */
export const isSharedOracleProject = (projectTypeClassCode) => {
    if (!projectTypeClassCode)
        return false;
    const normalized = projectTypeClassCode.trim().toUpperCase().replace(/\s+/g, '_');
    return SHARED_PROJECT_TYPE_CLASS_CODES.includes(normalized);
};
export const oracleProjectsResponseSchema = z.object({
    results: z.array(oracleProjectSchema),
});
